'use client';

import { useEffect, useRef } from 'react';

export default function ScrollProgress() {
    const barRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const update = () => {
            const bar = barRef.current;
            if (!bar) return;
            const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
            const pct = scrollHeight === clientHeight ? 0 : (scrollTop / (scrollHeight - clientHeight)) * 100;
            bar.style.width = `${pct}%`;
        };

        // Use passive listener for performance
        window.addEventListener('scroll', update, { passive: true });
        update(); // init
        return () => window.removeEventListener('scroll', update);
    }, []);

    return (
        <div
            aria-hidden="true"
            className="fixed top-0 left-0 right-0 z-[9999] h-[2px] bg-transparent pointer-events-none"
        >
            <div
                ref={barRef}
                className="h-full w-0 bg-[var(--color-md-primary)] transition-none origin-left"
                style={{ willChange: 'width' }}
            />
        </div>
    );
}
